import commonActions from '@/store/data/common/actions'
import { TECHNO_CATEGORIES } from '@/utils/constants'
import { webRequestClient } from '@/services'
import { isEmpty, get, concat } from 'lodash'
import { errorHandler } from '@/utils/helpers'
import helpers from './helpers'

const actions = {
    retrieveItems({ commit, rootState }) {
        //check if techno data is active for this user, if not, don't fetch it
        const dataType = get(rootState.data.settings.sociodemo, 'technology', null)
        if (!dataType) return

        commit('setIsLoading', true)
        const _route = helpers.buildRoutes(rootState.account)
        return webRequestClient
            .get(_route.route, _route.params)
            .then(device => {
                if (get(device, 'status') === 'KO') {
                    errorHandler('Error while retrieving devices', commit)
                } else if (!isEmpty(device.list)) {
                    const countryCode2 = get(rootState, 'account.country.code2', '')
                    commit('setRetrievedItems', {
                        items: concat(TECHNO_CATEGORIES.device, helpers.parseData(device.list, countryCode2))
                    })
                    commit('setCollection', helpers.instanciateAll(device.list, countryCode2))
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    }
}

export default {
    ...commonActions,
    ...actions
}
